var map = {
	"./blog.yml": 127,
	"./cloud.yml": 128,
	"./color.yml": 129,
	"./country.yml": 130,
	"./dio.yml": 131,
	"./doc.yml": 132,
	"./emoji.yml": 133,
	"./flag.yml": 134,
	"./git.yml": 135,
	"./icon.yml": 136,
	"./license.yml": 137,
	"./link.yml": 138,
	"./metrics.yml": 139,
	"./people.yml": 140,
	"./soft.yml": 141,
	"./src.yml": 142,
	"./status.yml": 143,
	"./taxonomy.yml": 144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;